export default __webpack_public_path__ + "static/media/widowmaker-noonecanhide.213ac538.mp3";